import React, { useState, useEffect } from "react";
import "./joined-bar.style.scss";
import NameList from "../name-list/name-list.component";
import {
  GuestJoinInRealTime,
  StartRoomInRealTime,
} from "../../firebase/firebase.utils";

const JoinedBar = ({
  hostDetails,
  room,
  guest,
  snapshotObj,
  handleUserKey,
}) => {
  const [hostList, setHostList] = useState([]);
  const [guestList, setGuestList] = useState([]);

  useEffect(() => {
    if (snapshotObj) {
      if (snapshotObj.host) {
        var hostArr = Object.entries(snapshotObj.host);
        setHostList(hostArr);
      } else {
        setHostList([]);
      }
      if (snapshotObj.guest) {
        var guestArr = Object.entries(snapshotObj.guest);
        setGuestList(guestArr);
      } else {
        setGuestList([]);
      }
    }
  }, [snapshotObj]);

  useEffect(() => {
    if (hostDetails.length) {
      const hostName = hostDetails[0].name;
      if ((hostName, room)) {
        const promise = StartRoomInRealTime(room, hostName);
        promise.then((key) => {
          handleUserKey({ user: "host", key: key });
        });
      }
    }
  }, [hostDetails]);

  useEffect(() => {
    if (guest.length) {
      console.log("GUEST VIEW");
      const promise = GuestJoinInRealTime(room, guest[0].name);
      promise.then((key) => {
        handleUserKey({ user: "guest", key: key });
      });
    }
  }, [guest]);

  return (
    <div className="joined-bar">
      <div className="name-list-wrapper">
        <NameList title="Host" list={hostList} />
      </div>
      <div className="name-list-wrapper">
        <NameList title="Participants" list={guestList} />
      </div>
    </div>
  );
};

export default JoinedBar;
